<template>
  <div id="contenedor-main-contrato" class="bkground">
    <v-container
      fluid>
      <v-card
        flat
        class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar
            :titulo="getContrato.numero"
            :datos="getContrato"
            :fechas="getContratoFechas"
            nombreRuta="contratos"
            mostrarBtnRegresar>
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        color="transparent"
        flat>
        <v-card-text class="pa-0">
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_FECHAS from '@/graphql/querys/administracion/contratos/fechas/contratoFechas.gql';
import TituloToolBar from './TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'MainContrato',
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {};
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoFechas: {
      query: CONTRATO_FECHAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getContratoFechas() {
      if (!this.contratoFechas) return [];
      return this.contratoFechas;
    },
  },
};
</script>

<style lang="scss">

</style>
